import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export const ReturnPolicy = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        data-testid="return-policy-dialog"
        className="max-w-2xl max-h-[85vh] overflow-y-auto bg-background"
      >
        <DialogHeader>
          <div className="font-mono-ui text-[10px] uppercase tracking-widest text-accent mb-2">
            Village Farm Food — Policies
          </div>
          <DialogTitle className="font-display text-3xl md:text-4xl font-semibold leading-tight">
            Return &amp; Refund Policy
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4 space-y-6 text-sm leading-relaxed text-foreground/85">
          <section>
            <h3 className="font-display text-lg text-foreground font-semibold">
              1. Fresh &amp; perishable items (Milk, Vegetables, Makhan, Curd)
            </h3>
            <p className="mt-2">
              Report any quality concern within <strong>4 hours of delivery</strong> by
              phone or WhatsApp on <strong>+91 93973 63140</strong>. We replace or
              refund the item — no questions asked.
            </p>
          </section>

          <section>
            <h3 className="font-display text-lg text-foreground font-semibold">
              2. Pantry items (Ghee, Oil, Spices, Seeds, Aata, Dry Fruits, Laddu)
            </h3>
            <p className="mt-2">
              Sealed and undamaged items can be returned within{" "}
              <strong>7 days of delivery</strong>. Damaged, leaking or
              incorrectly-shipped items are eligible for a full replacement or
              refund at any time.
            </p>
          </section>

          <section>
            <h3 className="font-display text-lg text-foreground font-semibold">
              3. How to raise a return
            </h3>
            <ol className="mt-2 list-decimal list-inside space-y-1">
              <li>Call or WhatsApp <strong>+91 93973 63140</strong>, or email <strong>hello@villagefarmfood.com</strong>.</li>
              <li>Share your order number, product name and a short photo of the issue.</li>
              <li>Our team confirms within 24 hours and arranges pickup or a replacement dispatch.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-display text-lg text-foreground font-semibold">
              4. Refund timeline
            </h3>
            <p className="mt-2">
              Approved refunds are credited back to your original payment method
              or your <strong>Pantry Wallet</strong> (whichever is faster) within{" "}
              <strong>5–7 working days</strong>.
            </p>
          </section>

          <section>
            <h3 className="font-display text-lg text-foreground font-semibold">
              5. Non-returnable
            </h3>
            <p className="mt-2">
              Opened or partially-used pantry items, and custom bulk orders once
              dispatched, are not eligible for return unless there's a product
              defect from our side.
            </p>
          </section>

          <div className="border-t border-border pt-5 text-xs text-muted-foreground">
            <div><strong>Village Farm Food</strong> · Village Malkash, Post Bhadi</div>
            <div>Tehsil Bhadra, District Hanuman Garh, Rajasthan — 335501</div>
            <div className="mt-1">Updated Feb 2026</div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
